<ng-container *ngIf="!workflow; else workflowTemplate">
  <button
    *appHasPermission="['appointment.edit', 'message.create']"
    mat-icon-button
    [matMenuTriggerFor]="confirmationMenu"
    [matTooltip]="getAppointmentConfirmationStatusTitleText()"
    matTooltipPosition="above"
    (click)="$event.stopPropagation()"
  >
    <mat-progress-spinner
      *ngIf="inProgress"
      diameter="30"
      mode="indeterminate"
    ></mat-progress-spinner>
    <mat-icon
      *ngIf="!inProgress"
      [ngClass]="getAppointmentConfirmationStatusColor()"
    >
      <ng-container *ngIf="appointment.patientConfirmed === true">thumb_up</ng-container>
      <ng-container *ngIf="appointment.patientConfirmed === false">thumb_down</ng-container>
      <ng-container *ngIf="appointment.patientConfirmed == null">thumb_up_off_alt</ng-container>
    </mat-icon>
  </button>

  <mat-menu #confirmationMenu="matMenu">
    <ng-container *appHasPermission="'message.create'">
      <button
        *ngIf="!appointment.cancelled && appointment.patientConfirmed == null"
        mat-menu-item
        [matMenuTriggerFor]="confirmationSendMenu"
      >
        <mat-icon>send</mat-icon>
        <span>Send confirmation request</span>
      </button>
    </ng-container>
    <ng-container *appHasPermission="'appointment.edit'">
      <button mat-menu-item (click)="markAppointmentConfirmation(true)">
        <mat-icon>thumb_up</mat-icon>
        <span>Mark as Confirmed</span>
      </button>
      <button mat-menu-item (click)="markAppointmentConfirmation(false)">
        <mat-icon>thumb_down</mat-icon>
        <span>Mark as Rejected</span>
      </button>
    </ng-container>
  </mat-menu>

  <mat-menu #confirmationSendMenu="matMenu">
    <button mat-menu-item (click)="openSendMessageConfirmationDialog('sms')">
      {{ 'common.send-via.text' | translate }}
    </button>
    <button mat-menu-item (click)="openSendMessageConfirmationDialog('email')">
      {{ 'common.send-via.email' | translate }}
    </button>
  </mat-menu>
</ng-container>

<ng-template #workflowTemplate>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
    <mat-icon
      [ngClass]="getAppointmentConfirmationStatusColor()"
      fxFlex="25px"
    >
      <ng-container *ngIf="appointment.patientConfirmed === true">thumb_up</ng-container>
      <ng-container *ngIf="appointment.patientConfirmed === false">thumb_down</ng-container>
      <ng-container *ngIf="appointment.patientConfirmed == null">thumb_up_off_alt</ng-container>
    </mat-icon>
    <span>{{ getAppointmentConfirmationStatusTitleText() }}</span>
  </div>
</ng-template>
